import intance from '../../../util/axios';

export const loginByAuth = async (values) => {
  let URL = 'admin/v1/login';
  console.log('🚀 ~ loginByAuth ~ URL:', URL);
  const response = await intance.post(URL, values);
  console.log('res...', response);
  const res = response;
  return res;
};
